// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M11.753.035a.792.792 0 0 0-.457.44l-.052.113-.006 5.322-.007 5.321-5.321.007-5.322.006-.136.064a.868.868 0 0 0-.383.361.842.842 0 0 0-.022.6.811.811 0 0 0 .404.423l.137.064 5.322.006 5.321.007.007 5.321.006 5.322.064.137c.282.6 1.102.6 1.384 0l.064-.137.006-5.322.007-5.321 5.321-.007 5.322-.006.137-.064c.172-.08.338-.25.393-.398a.724.724 0 0 1 .062-.137c.025-.029.026-.356.001-.34-.01.006-.038-.04-.06-.105-.054-.151-.221-.322-.396-.404l-.137-.064-5.322-.006-5.321-.007-.007-5.321-.006-5.322-.064-.137a.81.81 0 0 0-.418-.402.875.875 0 0 0-.521-.014M.008 12c0 .099.004.14.01.09.005-.05.005-.13 0-.18-.006-.05-.01-.009-.01.09"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const PlusIcon = Icon;
export default PlusIcon;
